function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import * as fudouActiveApi from '@/api/fudouActiveApi.js';
import { categoryApi } from '@/api/store';
import throttle from '@/utils/throttle';
import * as suplierCouponsApi from '@/api/suplierCouponsApi.js';
import * as dangaoActApi from '@/api/dangaoActApi';
export default {
  components: {},
  data: function data() {
    return {
      visibleDrawer: false,
      //是否为展开
      constants: this.$constants,
      listPram: {
        page: 1,
        limit: this.$constants.page.limit[0]
      },
      listData: {
        list: [],
        total: 0
      },
      listLoading: true,
      initDetail: {},
      brandOption: [],
      // 品牌
      selectIds: [],
      selectLists: []
    };
  },
  mounted: function mounted() {
    this.searchBrand('');
    this.listData = {
      list: [],
      total: 0
    };
  },
  methods: _defineProperty(_defineProperty({
    throttle: throttle,
    // 打开
    initOpen: function initOpen(row) {
      this.initDetail = row || {};
      this.handlerGetListData(this.listPram);
      this.visibleDrawer = true;
    },
    // 关闭
    closeDrawer: function closeDrawer() {
      this.visibleDrawer = false;
    },
    // 搜索
    handerSearch: function handerSearch() {
      var _this$listPram;
      var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      if (!((_this$listPram = this.listPram) !== null && _this$listPram !== void 0 && _this$listPram.brandId) && type == 'brand') {
        this.searchBrand('');
      }
      ;
      this.listPram.page = 1;
      this.handlerGetListData(this.listPram);
    },
    // 列表分页查询
    handlerGetListData: function handlerGetListData() {
      var _this = this;
      var pram = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      this.listLoading = true;
      dangaoActApi.getcakeLists(_objectSpread(_objectSpread({}, pram), {}, {
        storeId: this.initDetail.id
      })).then(function (data) {
        _this.listData = data;
        _this.listLoading = false;
      }).catch(function (err) {
        _this.listLoading = false;
      });
    },
    handleSizeChange: function handleSizeChange(val) {
      this.listPram.limit = val;
      this.handlerGetListData(this.listPram);
    },
    // 翻页
    handleCurrentChange: function handleCurrentChange(val) {
      this.listPram.page = val;
      this.handlerGetListData(this.listPram);
    },
    // 品牌查询
    searchBrand: function searchBrand() {
      var _this2 = this;
      var keyword = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      this.brandOption = [];
      dangaoActApi.getAllDangaoBrand(keyword).then(function (res) {
        _this2.brandOption = res && res.length && res.map(function (item) {
          var _ref = item || {},
            brandId = _ref.brandId,
            brandName = _ref.brandName,
            source = _ref.source;
          return {
            id: brandId,
            brandName: brandName,
            brandStr: "".concat(brandName, "--ID").concat(brandId, "\u3010").concat(source, "\u3011")
          };
        }) || [];
      });
    },
    // 搜索品牌
    handleAgreementSearch: function handleAgreementSearch(data) {
      var _this3 = this;
      this.throttle(function () {
        _this3.searchBrand(data);
      }, 300)();
    },
    // 批量移除
    batchRemove: function batchRemove(removeIds) {
      var _this4 = this;
      this.$confirm('移除后数据不能被恢复，确认移除吗！', '确定移除').then(function (result) {
        fudouActiveApi.deleteBind({
          skuIds: removeIds,
          channelId: _this4.initDetail.id
        }).then(function (data) {
          _this4.$message.success('删除数据成功');
          _this4.handlerGetListData(_this4.listPram);
          _this4.selectIds = [];
          _this4.selectLists = [];
        });
      });
    }
  }, "closeDrawer", function closeDrawer() {
    this.visibleDrawer = false;
    this.$emit('doRefresh');
  }), "handleSelectionChange", function handleSelectionChange(selection) {
    this.selectIds = selection.map(function (item) {
      return item.skuId;
    });
    this.selectLists = selection || [];
  })
};